<!--  -->
<template>
  <div class="month-list-box">
    <div class="action-bar">
      <div class="month-list-box">
        <!--操作栏-->
        <div class="action-bar">
          <el-select
            v-model="params.peportType"
            size="small"
            placeholder="请选择报表类型"
            @change="getMonthlyList('status')"
          >
            <el-option
              v-for="(item, i) in PeportTypeList"
              :value="item.value"
              :label="item.label"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            v-model="params.discType"
            size="small"
            placeholder="请选择商区类型"
            @change="getMonthlyList('status')"
            clearable
          >
            <el-option
              v-for="(item, i) in discTypeList"
              :value="item.value"
              :label="item.label"
              :key="i"
            ></el-option>
          </el-select>
          <el-input
            size="small"
            clearable
            placeholder="商区"
            v-model="params.discCode"
            @change="getMonthlyList('status')"
            class="param-input"
          />
          <el-input
            size="small"
            clearable
            placeholder="账号"
            v-model="params.name"
            @change="getMonthlyList('status')"
            class="param-input"
          />
          <el-input
            size="small"
            clearable
            placeholder="备注"
            v-model="params.remark"
            @change="getMonthlyList('status')"
            class="param-input"
          />
          <el-date-picker
            v-model="time"
            align="right"
            size="small"
            type="month"
            placeholder="选择月份"
            :picker-options="pickerOptions"
            @change="changeTime"
          ></el-date-picker>
          <el-button type="primary" size="small" @click="getMonthlyList('status')">搜索</el-button>
          <el-button type="primary" size="small" @click="exportdata">导出</el-button>
        </div>
        <div>
          <el-checkbox v-model="isDed" label="切换到扣量" @click="isExpandOne"></el-checkbox>
        </div>
        <!-- 报表标题 -->
        <div style="font-size:20px;text-align:center;margin-bottom:10px">
          <span>{{ this.month + "月-" }}</span>
          <span>
            {{
            params.peportType === 0
            ? "新增统计报表"
            : params.peportType === 1
            ? "日活统计报表"
            : params.peportType === 2
            ? "消费统计报表"
            : params.peportType === 3
            ? "ARPU统计报表"
            : "累计ARPU统计报表"
            }}
          </span>
        </div>
        <!--数据表格-->
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="remark" label="备注" align="center" min-width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="discType" label="商区类型" align="center" min-width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.discType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="disc" label="商区" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.disc }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="账号" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="params.peportType === 0"
            prop="totalNewUser"
            label="本月注册"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.totalNewUser|fixed2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="params.peportType === 1"
            prop="avgVisit"
            label="日均活跃"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.avgVisit|fixed2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="params.peportType === 2"
            prop="mp"
            label="本月业绩"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.mp|fixed2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="params.peportType === 3"
            prop="avgARPU"
            label="日均"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.avgARPU|fixed2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sumAvgARPU"
            v-if="params.peportType === 4"
            label="累计日均"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.sumAvgARPU|fixed2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(day, i) in days"
            :key="i"
            :label="i + 1 + '日'"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span
                v-if="isDed"
              >{{ scope.row.dedDailyData[i + 1] ? (scope.row.dedDailyData[i + 1]|fixed2): "无"}}</span>
              <span
                v-else
              >{{ scope.row.dailyData[i + 1] ? (scope.row.dailyData[i + 1]|fixed2 ): "无"}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <el-pagination
          :page-sizes="[10, 15, 20, 25]"
          :current-page="params.pageNumber"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
      <div class="zw"></div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import { changeTime } from "@/utils/global";
import * as define from "./define";
import local from "@/utils/localStroage";
export default {
  data() {
    return {
      showMap: {},
      isDed: false,
      //服务器响应参数:
      total: 0,
      list: [],
      peportType: "",
      month: "",
      //页面所需参数:
      time: "",
      dialogVisible: false,
      //   title: "每月报表",
      tableData: [], //Table表显示数据
      loading: false,
      PeportTypeList: [
        { label: "新增统计", value: 0 },
        { label: "日活统计", value: 1 },
        { label: "消费统计", value: 2 },
        { label: "ARPU统计", value: 3 },
        { label: "累计ARPU统计", value: 4 },
      ],
      discTypeList: [
        { label: "cps", value: 0 },
        { label: "cpa", value: 1 },
        { label: "cpt", value: 2 },
        { label: "cpc", value: 3 },
      ],
      lableMap: define.LableMap,
      // 请求列表参数
      params: {
        peportType: 0, //required
        pageNumber: 1, //required
        pageSize: 10, //required
        sumDate: "",
        discCode: "", //商区码
      },
      days: [], //当月日期数组
      months: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    let actJson = local.get("userInfo").actJson
      ? JSON.parse(local.get("userInfo").actJson)
      : {};
    this.initShowMap(actJson.checked);
    this.initShowMap(actJson.halfChecked);
    this.getMonthlyList();
    let date = new Date();
    this.days = new Array(date.getDate());
    this.months = date.getMonth();
  },
  methods: {
    //初始化显示项
    initShowMap(actJson) {
      if (!actJson) return false;
      for (let k in actJson) {
        let auth = actJson[k];
        if (auth.children) {
          this.initShowMap(auth.children);
        }
        if (typeof auth === "string") {
          this.showMap[auth] = true;
        } else {
          this.showMap[auth.name] = true;
        }
      }
    },
    //根据勾选权限判断是否显示
    hasItemAuth(key) {
      if (!this.showMap[key]) return false;
      return this.showMap[key];
    },
    isExpandOne() {
      this.isDed = this.isDed ? false : true;
    },
    // 请求订单统计列表
    getMonthlyList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      let params = Object.assign(this.params, {
        peportType: this.params.peportType,
        srd: this.hasItemAuth("isRealData3"),
      });
      API.getMonthlyList(params)
        .then((res) => {
          if (res.code === 200 && res.data.list.length !== 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.month = res.data.month;
            this.params.peportType = res.data.peportType;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 导出数据
    exportdata() {
      let params = paramsFilter({
        ...this.params,
        lableMap: JSON.stringify(this.lableMap),
        srd: this.hasItemAuth("isExport2"),
      });
      let str = "";
      for (let key in params) {
        if (key == "sumDate") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);
      let url = baseConfig.baseServerUrl + "/export/disc/monthly/list?" + str;
      window.location.href = url;
    },

    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getMonthlyList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getMonthlyList();
    },
    // 打开弹窗
    open(row) {
      this.dialogVisible = true;
      this.params.discCode = row.disc;
      this.getMonthlyList();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        pageNumber: 1,
        pageSize: 10,
        sumDate: "",
        discCode: "", //商区码
        peportType: "",
      };
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.sumDate = changeTime(time) || "";
        //获取指定月份有多少天:
        // this.days= new Date(year, month, 0).getDate()
        // 使用 new Date() 创建时间对象时，如果 date 传入 0，就能直接通过 getDate() 获取到最后一天的日期
        let date = new Date(time.getFullYear(), time.getMonth() + 1, 0);
        this.days = date.getDate();
      } else {
        this.params.sumDate = "";
      }
      this.getMonthlyList();
    },
  },
};
</script>

<style lang="" scoped></style>
